import { render } from "./ResolveOrphanedPayments.vue?vue&type=template&id=49afe1d4&scoped=true"
import script from "./ResolveOrphanedPayments.vue?vue&type=script&lang=js"
export * from "./ResolveOrphanedPayments.vue?vue&type=script&lang=js"

import "./ResolveOrphanedPayments.vue?vue&type=style&index=0&id=49afe1d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49afe1d4"]])

export default __exports__